import React from "react"

import KeenSlider from "../shared/KeenSlider"
import GetWindowWidth from "../shared/GetWindowWidth"

const MainSlider = ({ slidesDesktop, slidesMobile }) => {
  const showSlider = slidesDesktop && slidesDesktop.length > 0
  const showSliderMobile = slidesMobile && slidesMobile.length > 0

  if (!showSlider || !showSliderMobile) return null

  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600

  const slides = isDesktop ? slidesDesktop : slidesMobile

  return <KeenSlider keenSlider={slides} />
}

export default MainSlider
